import { Component, OnInit } from '@angular/core';
const topSiteChartData = {
  chart: {
    placevaluesinside: '0',
    showDivLineValues: '1',
    showvalues: '1',
    plottooltext: '<b>$dataValue</b> visitors from $label in $seriesName',
    theme: 'fusion',
    paletteColors: '#428DFF, #005AA2',
    maxBarHeight: '6',
    bgColor: '#fdfdfd',
    plotPaddingPercent: '40'
  },
  categories: [
    {
      category: [
        {
          label: 'Mumbai'
        },
        {
          label: 'Nagpur'
        },
        {
          label: 'Kohlapur'
        }
      ]
    }
  ],
  dataset: [
    {
      seriesname: 'Views',
      data: [
        {
          value: '77899'
        },
        {
          value: '61967'
        },
        {
          value: '52308'
        }
      ]
    },
    {
      seriesname: 'Reach',
      data: [
        {
          value: '28876'
        },
        {
          value: '19837'
        },
        {
          value: '20876'
        }
      ]
    }
  ]
};
@Component({
  selector: 'app-grouped-bar-chart',
  templateUrl: './grouped-bar-chart.component.html',
  styleUrls: ['./grouped-bar-chart.component.scss']
})
export class GroupedBarChartComponent implements OnInit {
  width = 600;
  height = 400;
  dataFormat = 'json';
  topSiteChartDataD = topSiteChartData;
  constructor() { }

  ngOnInit() {
  }

}
